import { render, staticRenderFns } from "./LegalProvider.vue?vue&type=template&id=308af824&scoped=true&"
import script from "./LegalProvider.vue?vue&type=script&lang=js&"
export * from "./LegalProvider.vue?vue&type=script&lang=js&"
import style0 from "./LegalProvider.vue?vue&type=style&index=0&id=308af824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308af824",
  null
  
)

export default component.exports